@if (collection()) {
  <div class="flex items-center justify-between p-1">
    <span class="mat-subtitle-2 ml-4 !text-secondary">Sida: {{ collection().page }}</span>
    <div class="flex items-center">
      <button mat-icon-button [disabled]="collection().page <= 1" (click)="page.emit(1)">
        <mat-icon>first_page</mat-icon>
      </button>
      <button mat-icon-button [disabled]="collection().page <= 1" (click)="page.emit(collection().page - 1)">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button mat-icon-button [disabled]="!collection().next" (click)="page.emit(collection().page + 1)">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </div>
}
